common.View.create('website::layouts.Main', {

    onDOMLoad() {
        this.initResize();
        this.initFirstCanvas();
        this.initAnimations();
    },

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)===' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },

    // Re-load functions on resize
    initResize()
    {
        $(window).resize(() => {
            this.initFirstCanvas();
        });
    },

    initAnimations() {
        let sal = require('sal.js');

        sal();
    },

    initFirstCanvas()
    {
        setTimeout(() => {
            // Is less than a laptop?
            if( (this.element.find('header').hasClass('cases') || this.element.find('header').hasClass('cases2')) &&
                !this.element.find('.canvas\\:\\:Canvas > :first-child').hasClass('canvas-blocks-custom-absoluteImage-Block')
            ) {
                this.element.find('.canvas\\:\\:Canvas')
                    .find('> :first-child')
                    .css('padding-top', this.element.find('header > :first-child').height() + 'px')
            }

            // Add padding for absolute image based on heading
            if( this.element.find('.canvas\\:\\:Canvas').find('> :first-child').hasClass('canvas-blocks-custom-absoluteImage-Block') ) {
                this.element.find('.canvas\\:\\:Canvas')
                    .find('> :nth-child(2)')
                    .css('padding-top', this.element.find('header > :first-child').height() + 'px')
            }
        }, 1);
    },

});
